import {connect} from "react-redux";
import CompleteParkingActivity from "./Complete";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {viewActivity} from "../../../../service/Activity/action";
import {getPendingActivity} from "../../../../service/Parking/action";
import {activityTypes, getSenior} from "../../../../service/Dealer/action";
import {saveActivity, markAttendance} from "../../../../service/Parking/action";
import {isCheckout} from "../../../../service/CarService/action";
import {errorLogs} from "../../../../service/FasttagToll/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    senior: state.Dealer.senior,
    activityByIdDetails:state.Activity.activityByIdDetails,
    saveActivityRes:state.Parking.saveActivityRes,
    pendingActivity:state.Parking.pendingActivity,
    attendance:state.Parking.attendance,
    activityTypesDetails:state.Dealer.activityTypesDetails,
    isCheckoutDetails:state.CarService.isCheckout,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            viewActivity,
            saveActivity,
            getPendingActivity,
            activityTypes,
            getSenior,
            isCheckout,
            markAttendance,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompleteParkingActivity);
